import * as types from "./reportActionTypes";

export const loadReports = () => {
  return { type: types.LOAD_REPORTS };
};

export const loadReportsSuccess = reports => {
  return { type: types.LOAD_REPORTS_SUCCESS, reports };
};

export const loadReportsFailed = message => {
  return { type: types.LOAD_REPORTS_FAILED, message };
};

export const selectFilter = value => {
  return { type: types.SELECT_FILTER_REPORTS, value };
};

export const downloadReport = (reportId, filename) => {
  return { type: types.DOWNLOAD_REPORT, payload: { reportId, filename } };
};

export const downloadReportFailed = message => {
  return { type: types.DOWNLOAD_REPORT_FAILED, message };
};

export const downloadReportSuccess = report => {
  return { type: types.DOWNLOAD_REPORT_SUCCESS, report };
};



// WEBPACK FOOTER //
// ./src/reports/reportActions.js